define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');
  return IpsModel.extend({
    validation:{
      serviceRequest:{
        required: true,
      }
    },
    urlRoot: '/delegate/civics-api/api/crm/servicerequests/{0}/logs',
    url: function() {
		    return this.urlRoot.format(this.get('serviceRequest'));
		},
  });
});
